<template>
  <el-dialog
    custom-class="dialog-wrapper scroll-dialog"
    :title="dialogTitle"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    v-model="dialogVisible"
  >
    <div class="item-title">
      屏蔽总开关 <span class="optional-tip">（选填，可多选）</span>
    </div>
    <el-form :inline="true">
      <el-form-item label="手机系统">
        <el-select
          multiple
          v-model="systemBlock"
          placeholder="可多选，已选不可重复"
          class="campus-select"
        >
          <el-option label="HarmonyOS" value="2"></el-option>
          <el-option label="Android" value="0"></el-option>
          <el-option label="iOS" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="item-title">
      版本号屏蔽 <span class="optional-tip">（选填）</span>
    </div>
    <el-form :inline="true">
      <div
        class="margin-bottom-10"
        v-for="(item, index) in versionBlock"
        :key="'ver-' + index"
      >
        <el-form-item label="手机系统">
          <el-select v-model="item.osType">
            <el-option label="HarmonyOS" value="2"></el-option>
            <el-option label="Android" value="0"></el-option>
            <el-option label="iOS" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本号">
          <el-input v-model="item.version" placeholder="不限制"></el-input>
        </el-form-item>
        <el-button v-if="index == 0" type="primary" @click="clickAddVersion"
          >添加</el-button
        >
        <el-button
          v-if="index != 0"
          type="danger"
          icon="delete"
          @click="clickDeleteVersion(index)"
        ></el-button>
      </div>
    </el-form>

    <div class="item-title">应用校区 <span class="required-tip">*</span></div>
    <el-form>
      <el-form-item label="校区范围">
        <el-radio-group v-model="campusType">
          <el-radio label="1">全量</el-radio>
          <el-radio label="2">部分</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="屏蔽校区" v-if="campusType === '1'">
        <el-select
          filterable
          multiple
          v-model="unidListA"
          placeholder="选填，可添加多个"
          class="campus-select"
        >
          <el-option
            v-for="c in campusDataSource"
            :key="c.value"
            :label="c.label"
            :value="c.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="生效校区" v-if="campusType === '2'">
        <el-select
          multiple
          v-model="unidListB"
          placeholder="必填，可添加多个"
          class="campus-select"
        >
          <el-option
            v-for="c in campusDataSource"
            :key="c.value"
            :label="c.label"
            :value="c.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <template #footer>
      <div class="flex-row-center">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="clickEditDone">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogTitle: "",
    dataSource: {},
    campusDataSource: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      dialogVisible: false,
      systemBlock: [], // 多选系统屏蔽，字符串 "0"/"1"/"2"
      versionBlock: [{ osType: "", version: "" }],
      campusType: "", // "1" 全量 / "2" 部分
      unidListA: [],
      unidListB: [],
    };
  },

  methods: {
    // 发送更新
    sendUpdate() {
      const resValue = {};
      if (this.systemBlock && this.systemBlock.length) {
        resValue["systemBlock"] = this.systemBlock.map(Number); // 数字数组
      }
      const versionValue = this.versionBlock
        .filter(
          (item) =>
            item.osType &&
            item.osType !== "" &&
            item.version &&
            item.version !== ""
        )
        .map((item) => ({ osType: item.osType, version: item.version }));
      if (versionValue.length) {
        resValue["versionBlock"] = versionValue;
      }
      resValue["campusType"] = this.campusType; // "1"/"2"
      resValue["unidList"] =
        +this.campusType === 1 ? this.unidListA : this.unidListB; // 数字数组

      const param = {
        tag: this.dataSource.tag,
        key: this.dataSource.resKey,
        value: JSON.stringify(resValue),
      };

      this.$http({
        url: this.$util.domain + "/adminapi/v1/tools/addOrUpdateConfig",
        method: "POST",
        dataType: "json",
        body: JSON.stringify(param),
      })
        .then((res) => {
          if (res.data.error === 10000) {
            this.dialogVisible = false;
            this.$emit("refresh");
          } else {
            this.$util.errorMsg(res.message);
          }
        })
        .catch((error) => {
          this.$util.errorMsg("保存失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 点击编辑：回填已有数据
    clickEdit() {
      // 先重置，避免缓存
      this.systemBlock = [];
      this.versionBlock = [{ osType: "", version: "" }];
      this.campusType = "";
      this.unidListA = [];
      this.unidListB = [];

      if (this.dataSource.resValue && this.dataSource.resValue !== "") {
        try {
          const resValue = JSON.parse(this.dataSource.resValue);
          if (resValue.systemBlock && Array.isArray(resValue.systemBlock)) {
            this.systemBlock = resValue.systemBlock.map(String);
          }
          if (resValue.versionBlock && Array.isArray(resValue.versionBlock)) {
            this.versionBlock = resValue.versionBlock.map((item) => ({
              osType: String(item.osType),
              version: item.version || "",
            }));
          }
          if (resValue.campusType) {
            this.campusType = String(resValue.campusType);
          }
          // 校区下拉 value 为数字，回填保持 number 才能正确匹配中文 label
          if (resValue.unidList && Array.isArray(resValue.unidList)) {
            +resValue.campusType === 1
              ? (this.unidListA = resValue.unidList)
              : (this.unidListB = resValue.unidList);
          }
        } catch (error) {
          console.log("数字悦动广告-解析数据失败:", error);
        }
      }
      this.dialogVisible = true;
    },

    // 版本号屏蔽：添加
    clickAddVersion() {
      this.versionBlock.push({ osType: "", version: "" });
    },
    // 版本号屏蔽：删除
    clickDeleteVersion(index) {
      this.versionBlock.splice(index, 1);
    },

    // 确认：校验必填项后保存
    clickEditDone() {
      if (!this.campusType) {
        this.$util.errorMsg("请选择应用校区");
        return;
      }
      if (
        this.campusType === "2" &&
        (!this.unidListB || this.unidListB.length === 0)
      ) {
        this.$util.errorMsg("部分模式请至少选择一个生效校区");
        return;
      }
      this.sendUpdate();
    },
  },
};
</script>

<style scoped>
.item-title {
  font-size: 16px;
  font-weight: 500;
  margin: 10px 0;
}

.optional-tip {
  font-size: 12px;
  font-weight: 400;
  color: #999;
}

.required-tip {
  font-size: 12px;
  font-weight: 400;
  color: #f56c6c;
}

.el-select {
  width: 200px;
}

.el-input {
  width: 200px;
}

.campus-select {
  width: 460px;
}
</style>

<style>
.scroll-dialog > .el-dialog__body {
  max-height: 60vh;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// DigitalYuedongAdShield.vue?4936dda0